//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      progress: 0,
      progressInterval: null,
      done: false,
      transition: true,
    };
  },
  computed: {
    ...mapGetters('importacao', {
      importacoesAndamento: 'getImportacoesAndamento',
      tiposImportacao: 'getTiposImportacao',
    }),
    quantidadeAndamento() {
      return this.importacoesAndamento.length;
    },
  },
  methods: {
    startProgress() {
      this.progressInterval = window.setInterval(() => {
        this.progress += 3;

        if (this.progress >= 115) {
          this.done = true;
          window.clearInterval(this.progressInterval);
          window.setTimeout(() => {
            this.done = false;
          }, 3E3);
        }
      }, 1E2);
    },
    restartProgress() {
      this.progress = 0;
      this.transition = false;
      this.done = false;

      window.clearInterval(this.progressInterval);
      window.setTimeout(() => {
        this.transition = true;
        this.startProgress();
      }, 600);
    },
    goToImportPage() {
      this.$emit('RESET_SIDEBAR');
      this.$router.push({ name: 'importacoes' });
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/badge/Badge.vue?vue&type=script&lang=js&